import { Link } from "react-router-dom";
import { RewardsStrip } from "./RewardsStrip";

export function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <RewardsStrip />
      <div>
        <img className="footer-logo" src="/assets/dolo-logo.png" alt="Dolo logo" data-testid="footer-logo" />
        <p className="footer-brand">DOLO'S WORLD</p>
        <p>Wasteland Runner Vol. 1 web experience.</p>
      </div>
      <div className="footer-links">
        <Link to="/character-book" data-testid="footer-character-book-link">
          CHARACTER BOOK
        </Link>
        <a href="https://dolosworld.com" target="_blank" rel="noreferrer" data-testid="footer-domain-link">
          DOLOSWORLD.COM
        </a>
      </div>
      <div className="footer-badge">
        <a
          className="copyrighted-badge"
          title="Copyrighted.com Registered & Protected"
          target="_blank"
          rel="noreferrer"
          href="https://app.copyrighted.com/website/0wYHu9Dp6pv7gpbx/"
          data-testid="footer-copyrighted-badge"
        >
          <img
            alt="Copyrighted.com Registered & Protected"
            width="125"
            height="25"
            srcSet="https://static.copyrighted.com/badges/125x25/06_1_2x.png 2x"
            src="https://static.copyrighted.com/badges/125x25/06_1.png"
          />
        </a>
      </div>
    </footer>
  );
}
